export const siteColors = {
  cyan: "#5ac1d2",
  purple: "#974b97",
  white: "#fff",
  darkGray: "#333",
  lightGray: "whitesmoke",
  black: "#000",
};
